<script lang="ts">
    import { tick } from 'svelte';
    import { cubicOut } from 'svelte/easing';
    import { get } from 'svelte/store';
    import { slide, fade } from 'svelte/transition';

    import { themeType as ThemeTypeEnum } from '../constants/Enums';
    import { StarImage, CloseIcon } from '../constants/imgList';
    import { JUMP_TYPE_ENUM } from '../enums';
    import { AWARD_PAGE_CK, PAGE_CLICK_CK } from '../enums/track';
    import {
        visible,
        isJumpOneLInk,
        loadingReward,
        awardCountdownSecondsLeft
    } from '../store/index';
    import { JumpLink } from '../utils/jumpTo';
    import { trackEvent } from '../utils/track';

    import webp from '@/actions/webp';
    import { pageLeave } from '@/utils/fmpTrack';

    export let downLoadType;
    export let logo;
    export let isBottom = false;

    export let onClose = () => {
        $visible = false;
        trackEvent(PAGE_CLICK_CK, {
            button_name: 'close'
        });
    };
    const onDownload = async () => {
        pageLeave();
        if (isBottom) {
            trackEvent(AWARD_PAGE_CK, {
                button_name: 'app_guide'
            });
        } else {

            trackEvent(PAGE_CLICK_CK, {
                button_name: 'finance_app'
            });
        }

        JumpLink(
            JUMP_TYPE_ENUM.TO_WEB2APP,
            isBottom
                ? { awardCountdownNumber: get(awardCountdownSecondsLeft) ?? 0 }
                : undefined
        );
    };

    $: quickDownloadBgClass =
        downLoadType === ThemeTypeEnum.BLACK ? 'bg-black' : 'bg-white';
    $: quickDownloadPositionClass =
        downLoadType === ThemeTypeEnum.BLACK ? 'is-top-absolute' : '';
    $: quickDownloadBottomThemeClass =
        downLoadType === ThemeTypeEnum.BLACK ? 'bottom-black' : 'bottom-white';
    $: quickDownloadBottomSpacingClass =
        isBottom && downLoadType === ThemeTypeEnum.WHITE ? 'bottom-white-spacing' : '';
    $: quickDownloadOutTransition =
        downLoadType === ThemeTypeEnum.WHITE
            ? { duration: 460, easing: cubicOut }
            : { duration: 300 };
    $: quickDownloadContentOutFade =
        downLoadType === ThemeTypeEnum.WHITE
            ? { duration: 280, easing: cubicOut }
            : { duration: 200 };

</script>

{#if $visible && !$loadingReward && !isBottom}
    <div
        class={`quick-download ${quickDownloadBgClass} ${quickDownloadPositionClass}`}
        out:slide={quickDownloadOutTransition}
        in:slide={{ duration: 300 }}
    >
        <div class="content" out:fade={quickDownloadContentOutFade}>
            <div class="left-section">
                <div class="app-icon" use:webp={logo} />
                <div class="info">
                    <div class="title">DiDi Finanzas: Rápido y seguro</div>
                    <div class="rating-container">
                        <div
                            class="star"
                            use:webp={StarImage[downLoadType]}
                            style="background: no-repeat center; background-size: contain;"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="right-section">
                <div
                    role={null}
                    class="download-btn"
                    on:click|stopPropagation={onDownload}
                >
                    Abrir
                </div>

                <div role={null} class="close-btn" on:click={onClose}>
                    <div class="icon" use:webp={CloseIcon[downLoadType]} />
                </div>
            </div>
        </div>
    </div>
{/if}
{#if isBottom}
    <div
        class={`quick-download quick-download-bottom ${quickDownloadBottomThemeClass} ${quickDownloadBottomSpacingClass}`}
        in:slide={{ duration: 300 }}
    >
        <div class="content">
            <div class="left-section">
                <div class="app-icon" use:webp={logo} />
                <div class="info">
                    <div class="title">DiDi Finanzas: Rápido y seguro</div>
                    <div class="rating-container">
                        <div
                            class="star"
                            use:webp={StarImage[downLoadType]}
                            style="background: no-repeat center; background-size: contain;"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="right-section">
                <div
                    role={null}
                    class="download-btn"
                    on:click|stopPropagation={onDownload}
                >
                    Abrir
                </div>
            </div>
        </div>
    </div>
{/if}
<style lang="scss">
    .bg-white {
        background: #ffffff;
        color: #0b0b0d;
    }
    .bg-black {
        color: #FFFFFF;
        background-color: #000000;
    }
    .bg-null {
        position: static !important;
        background: none;
        color: #ffffff;
    }
    .quick-download {
        z-index: 10;
        position: static;
        margin: auto;
        width: 7.5rem;
        height: 1.16rem;
        padding: 0.32rem 0.32rem 0.32rem 0.24rem;
        box-sizing: border-box;
        border: none;
        transform: translateZ(0);
    }

    .quick-download.is-top-absolute {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }
    .quick-download.quick-download-bottom {
        width: auto;
        margin: 0.16rem;
        height: 1.16rem;
        box-sizing: border-box;
        padding: 0.26rem;
        position: static;
    }
    .quick-download.quick-download-bottom.bottom-white {
        padding: 0.26rem 0.32rem;
        margin-top: 20px !important;
        background: #F2F2F5;
        color: #0b0b0d;
        border-radius: 20px;
    }
    .quick-download.quick-download-bottom.bottom-white-spacing {
        margin: 0 32px;
    }
    .quick-download.quick-download-bottom.bottom-black {
        background: #1c1d1e;
        color: #FFFFFF;
        border-radius: 32px;
    }

    .quick-download .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        margin: 0;
        padding: 0;
    }

    .quick-download .content .left-section {
        display: flex;
        gap: 0.2rem;
        align-items: center;
    }

    .quick-download .content .left-section .app-icon {
        width: 0.64rem;
        height: 0.64rem;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }

    .quick-download .content .left-section .info {
        display: flex;
        flex-direction: column;
        gap: 0.06rem;
    }

    .quick-download .content .left-section .info .title {
        font-size: 0.24rem;
        letter-spacing: 0;
        line-height: 0.32rem;
        font-family: 'DiDiSans-Pro-Bold';
    }

    .quick-download .content .left-section .info .rating-container {
        display: flex;
        align-items: center;
        gap: 0.06rem;
        height: 0.2rem;
    }

    .quick-download .content .left-section .info .rating-container .star {
        width: 1.08rem;
        height: 0.2rem;
    }

    .quick-download .content .right-section {
        display: flex;
        align-items: center;
        gap: 0.12rem;
    }

    .quick-download .content .right-section .download-btn {
        font-family: 'DiDiSans-Pro-Bold';
        background: none;
        border: none;
        color: #FF5F14;
        height: 0.32rem;
        font-size: 0.24rem;
        line-height: 0.32rem;
        cursor: pointer;
        position: relative;
    }

    /* 透明热区：不改变视觉，只扩大可点击范围 */
    .quick-download .content .right-section .download-btn::before {
        content: '';
        position: absolute;
        top: -0.28rem;
        bottom: -0.28rem;
        left: -0.16rem;
        right: 0;
        background: transparent;
        pointer-events: auto;
    }

    .quick-download .content .right-section .close-btn {
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    /* 透明热区：不改变视觉，只扩大可点击范围 */
    .quick-download .content .right-section .close-btn::before {
        content: '';
        position: absolute;
        top: -0.28rem;
        bottom: -0.28rem;
        left: 0;
        right: -0.16rem;
        background: transparent;
        pointer-events: auto;
    }

    .quick-download .content .right-section .close-btn .icon {
        width: 0.24rem;
        height: 0.24rem;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
</style>
